import axios from 'axios'
import { IssuerIntegratorListResponse } from 'src/models/issuerIntegrator.models'
import { GetIssuersResponse } from 'src/queries/issuers/issuerIntegrators/issuerIntegrators.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

// Both Redux thunks this module replaces (getIssuers / getIssuer in
// src/redux/actions/data/issuerIntegrators.actions.ts) used
// selectAuthedJsonApiRequestConfig, which maps to RequestConfig.Default.

export const getIssuers = async (): Promise<GetIssuersResponse> => {
  return getResponseData(
    axios.get<GetIssuersResponse>(
      `/issuers`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const getIssuer = async (
  issuerId: string,
): Promise<IssuerIntegratorListResponse> => {
  return getResponseData(
    axios.get<IssuerIntegratorListResponse>(
      `/issuers/${issuerId}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
